import { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ConfirmationBee from "client/assets/images/ConfirmationBee.svg";
import successBee from "client/assets/images/SuccessBee.svg";
import { PopupDialogbox } from "../../../../CommonComponents";
import { getCatalogItemByAssetModelId, setCatalogItemByAssetModelId } from "Store/Component/CatalogManagement/CatalogManagementAction";
import {
    operations as purchaseOrderOperations,
    selectors as purchaseOrderSelectors,
} from "../../../../../redux/PurchaseOrder";
import customerMyOrderDetails from "../../../../../redux/CustomerMyOrder/operations";
import PurchaseDetail from "./PurchaseDetail";
import { formatPrice } from "utils";
import Validation from "../../Requisition/RequisitionType/NonStandardEquipment/NonStandardEquipmentValidation"
import { AttributeName, CONSTANTS } from "client/utils/constants";
import { getRequistionDropDown, setRequistionDropDown } from "Store/AssetManagement/RequisitionDropDown/RequisitionDropDownAction";
import { getManagedEquipmentDropDown, setManagedEquipmentDropDown } from "Store/AssetManagement/ManagedEquipmentDropDown/ManagedEquipmentDropDownAction";
import EquipmentTypeDispatch from "Store/AssetManagement/Equipment/EquipmentDispatch";
import { getAssetType } from "Store/AssetManagement/AssetType/AssetTypeAction";
// PV/MV catalog search action (calls assets/vehicle/catalogitems)
import { getCatalogItemDetails } from "redux/MyOrder/action";
// ME catalog search action (calls assets/managedequipment/catalogitems)
import { getManagedEquipmentItemDetails } from "redux/ManagedEquipment/action";
import { saveCatalogOverride, setCatalogOverrideSaved } from "Store/Component/FleetManagement/FleetManagementAction";
import {
    hasMaterialCatalogOverrideChange,
    isCatalogOverrideBaselineReady,
    normalizeCatalogOverrideCriteria,
} from "./catalogOverrideSearchGating";

const PurchaseDetailContainer = (props: any) => {
    const meSearchCriteriaToFieldKeyMap: Record<string, string> = {
        manufacturerId: "manufacturer",
        categoryId: "category",
        stateAvailabilityId: "stateAvailability",
        programStatusId: "programStatus",
        annualHoursId: "annualHours",
        deckSizeId: "deckSize",
        deckTypeId: "deckType",
        autonomousId: "autonomous",
        sizeId: "size",
        typeId: "type",
        styleId: "style",
        lengthId: "length",
        fuelTankId: "fuelTank",
        chargingStationId: "chargingStation",
        treeCareEquipmentTypeId: "treeCareEquipmentType",
        horsePowerId: "horsePower",
        fuelTypeId: "fuelType",
        seatingCapacityId: "seatingCapacity",
        enclosedCabId: "enclosedCab",
        capacityId: "capacity",
    };
    const { isBulkOrderRequest, isRequisitionComplete } = props
    const check = props?.check
    const setClickPoolBtn = props?.setClickPoolBtn
    const currentItemNumber = useMemo(
        () => Number(String(props?.itemDetails?.itemId ?? "").split("-")[1]),
        [props?.itemDetails?.itemId]
    );
    const currentRequest = useMemo(() => {
        const requests = props?.orderDetails?.requests ?? [];
        const requestId = props?.itemDetails?.requestId ?? props?.purchaseOrderStepperData?.requestId;

        return (
            requests.find((request: any) => Number(request?.requestId) === Number(requestId)) ??
            requests.find((request: any) => Number(request?.itemNumber) === currentItemNumber) ??
            null
        );
    }, [currentItemNumber, props?.itemDetails?.requestId, props?.orderDetails?.requests, props?.purchaseOrderStepperData?.requestId]);

    // Resolve subtype from the current item's matching request, never from the first request in the order.
    const effectiveSubType = props?.itemDetails?.orderRequestSubType
        ?? currentRequest?.subOrderType;
    const isProductionVehicle = effectiveSubType === CONSTANTS.PRODUCTION_VEHICLE;
    const isManagementVehicle = effectiveSubType === CONSTANTS.MANAGEMENT_VEHICLE;
    const isManagedEquipment = props?.itemDetails?.orderRequestType === CONSTANTS.MANAGED_EQUIPMENT;
    const isCatalogOverrideEligible = isProductionVehicle || isManagementVehicle || isManagedEquipment;
    const catalogOverrideSubTypeId = props?.itemDetails?.orderRequestSubTypeId
        ?? currentRequest?.orderRequestSubTypeId;
    const instanceFleetRequestDetailId = props?.itemDetails?.fleetRequestDetailId;
    const fleetRequestDetailId = Number.isFinite(Number(instanceFleetRequestDetailId))
        ? Number(instanceFleetRequestDetailId)
        : null;

    // Initial states for catalog override criteria and dropdown values
    const initialCatalogOverrideCriteria = {
        upfitOption: null,
        snowSetup: null,
        vehicle: null,
        vehicleCapacity: null,
        noOfDoors: null,
        driveTrain: null,
        fuelType: null,
        driverTitle: null,
        equipmentType: null,
        managedEquipFields: {} as Record<string, any>,
    };

    // Named ME sub-dropdown lists — one entry per field, mirroring order creation sub-containers.
    // Shared as a reusable block so equipment-type-change handler can reset them all at once.
    const initialMENamedLists = {
        manufacturer: [] as any[], category: [] as any[],
        stateAvailability: [] as any[], programStatus: [] as any[],
        annualHours: [] as any[], deckSize: [] as any[],
        deckType: [] as any[], autonomous: [] as any[],
        size: [] as any[], type: [] as any[],
        style: [] as any[], length: [] as any[],
        fuelTank: [] as any[], chargingStation: [] as any[],
        seatingCapacity: [] as any[], enclosedCab: [] as any[],
        capacity: [] as any[], treeCareEquipmentType: [] as any[],
        horsePower: [] as any[], fuelType: [] as any[],
    };

    const initialCatalogOverrideDropDownValues = {
        upfitOptionList: [] as any[],
        snowSetupList: [] as any[],
        vehicleList: [] as any[],
        vehicleCapacityList: [] as any[],
        noOfDoorsList: [] as any[],
        driveTrainList: [] as any[],
        fuelTypeList: [] as any[],
        driverTitleList: [] as any[],
        equipmentTypeList: [] as any[],
        ...initialMENamedLists,
    };

    const [showPoolPopup, setshowPoolPopup] = useState(false);
    const [assetPoolError, setAssetPoolError] = useState("");
    const [isLicensedTitled, setIsLicensedTitle] = useState(false);
    const [catalogOverridePopupcontent, setCatalogOverridePopupcontent] = useState<any>(null);
    const [isCatalogOverrideEnabled, setIsCatalogOverrideEnabled] = useState<boolean>(false);
    const [showCatalogOverrideSection, setShowCatalogOverrideSection] = useState<boolean>(false);
    const [showCatalogComparePopup, setShowCatalogComparePopup] = useState<boolean>(false);
    const [pendingCatalogCompareAssetModelId, setPendingCatalogCompareAssetModelId] = useState<any>(null);
    const [selectedCatalogCompareItem, setSelectedCatalogCompareItem] = useState<any>({});
    const [isSearched, setIsSearched] = useState(false);
    const [catalogOverrideCriteria, setCatalogOverrideCriteria] = useState<any>(initialCatalogOverrideCriteria);
    const [catalogOverrideDropDownValues, setCatalogOverrideDropDownValues] = useState<any>(initialCatalogOverrideDropDownValues);
    const [catalogOverrideBaseline, setCatalogOverrideBaseline] = useState<any>(null);
    const [isCatalogOverrideBaselineCapturePending, setIsCatalogOverrideBaselineCapturePending] = useState(false);
    const [isManagedEquipmentPrefillComplete, setIsManagedEquipmentPrefillComplete] = useState(false);
    // Local state isolates search results from any other Redux consumer — cleared on section close
    const [catalogGridData, setCatalogGridData] = useState<any[]>([]);

    /**
     * Tracks IDs discovered during the pre-fill cascade so subsequent dispatch calls
     * can reference them synchronously without waiting for async state updates.
     */
    const preFillIdsRef = useRef<Record<string, any>>({});
    const isPvInitialPrefillRef = useRef<boolean>(true);
    const isMvInitialPrefillRef = useRef<boolean>(true);
    const isMeInitialPrefillRef = useRef<boolean>(true);
    const dispatch = useDispatch();
    const dispatchPoolGridData =
        purchaseOrderOperations.dispatchPoolGridData(dispatch);
    const dispatchPurchaseTypeDropdown =
        purchaseOrderOperations.dispatchPurchaseTypeDropdown(dispatch);
    const dispatchRegisteredDropdown =
        purchaseOrderOperations.dispatchRegisteredDropdown(dispatch);
    const dispatchStepperData =
        purchaseOrderOperations.dispatchSetPurchaseorderStepperData(dispatch);
    const activeRow = customerMyOrderDetails.dispatchRowData(dispatch);
    const dispatchEquipmentType = EquipmentTypeDispatch.dispatchGetEquipmentType(dispatch);
    const {
        poolGridData,
        purchaseType,
        registeredType,
        orderType,
        reasonCode,
        isVehicleConsolidatedChecked,
        isManageEquipConsolidatedChecked,
        isNonstandardConsolidatedChecked,
        catalogSpecificationList,
        catalogItemByAssetModelId,
        requisitionDropDown,
        equipmentDropdown,
        managedEquipmentDropDown,
        requisitionTypeList,
        pvMvCatalogDetails,
        pvMvCatalogFleetRequestDetailId,
        meCatalogDetails,
        meCatalogFleetRequestDetailId,
        currentUser,
        catalogOverrideSaved,
    }: any = useSelector((state: any) => ({
        poolGridData: purchaseOrderSelectors.getPoolGridData(state),
        purchaseType: purchaseOrderSelectors.getPurchaseTypeDropdown(state),
        registeredType: purchaseOrderSelectors.getRegisteredDropdown(state),
        orderType: purchaseOrderSelectors.getOrderTypeDropdown(state),
        reasonCode: state.ReasonCodeReducer.requisitionReasonCodeList,
        isVehicleConsolidatedChecked: state.FleetProcessingReducer.isVehicleConsolidatedChecked,
        isManageEquipConsolidatedChecked: state.FleetProcessingReducer.isManageEquipConsolidatedChecked,
        isNonstandardConsolidatedChecked: state.FleetProcessingReducer.isNonstandardConsolidatedChecked,
        catalogSpecificationList: state.CatalogItemReducer.catalogSpecificationList,
        catalogItemByAssetModelId: state.CatalogManagementReducer.catalogItemByAssetModelId,
        requisitionDropDown: state.RequisitionDropDownReducer.requisitionDropDown,
        equipmentDropdown: state.Equipment.EquipmentType,
        managedEquipmentDropDown: state.ManagedEquipmentDropDownReducer.managedEquipmentDropDown,
        requisitionTypeList: state.AssetManagement.AssetType,
        // Search results from assets/vehicle/catalogitems (PV/MV)
        pvMvCatalogDetails: state.MyOrder.catalogDetails,
        pvMvCatalogFleetRequestDetailId: state.MyOrder.catalogDetailsFleetRequestDetailId,
        // Search results from assets/managedequipment/catalogitems (ME)
        meCatalogDetails: state.ManagedEquipment.catalogDetails,
        meCatalogFleetRequestDetailId: state.ManagedEquipment.catalogDetailsFleetRequestDetailId,
        currentUser: state.UserReducer.currentUser,
        catalogOverrideSaved: state.fleetAdminTaskReducer.catalogOverrideSaved,
    }));

    const hasSelectedDropdownValue = (selectedOption: any) =>
        selectedOption?.value != null &&
        selectedOption?.value !== "" &&
        Number(selectedOption?.value) > 0;

    const isCatalogOverrideMandatorySelectionValid = useMemo(() => {
        if (isProductionVehicle) {
            const isVehicleCapacityRequired = !!catalogOverrideCriteria?.vehicle?.showVehicleCapacity;
            return (
                hasSelectedDropdownValue(catalogOverrideCriteria?.upfitOption) &&
                hasSelectedDropdownValue(catalogOverrideCriteria?.snowSetup) &&
                hasSelectedDropdownValue(catalogOverrideCriteria?.vehicle) &&
                hasSelectedDropdownValue(catalogOverrideCriteria?.noOfDoors) &&
                hasSelectedDropdownValue(catalogOverrideCriteria?.driveTrain) &&
                (!isVehicleCapacityRequired || hasSelectedDropdownValue(catalogOverrideCriteria?.vehicleCapacity))
            );
        }

        if (isManagementVehicle) {
            return (
                hasSelectedDropdownValue(catalogOverrideCriteria?.driverTitle) &&
                hasSelectedDropdownValue(catalogOverrideCriteria?.vehicle) &&
                hasSelectedDropdownValue(catalogOverrideCriteria?.driveTrain)
            );
        }

        if (isManagedEquipment) {
            return hasSelectedDropdownValue(catalogOverrideCriteria?.equipmentType);
        }

        return false;
    }, [catalogOverrideCriteria, isProductionVehicle, isManagementVehicle, isManagedEquipment]);

    const normalizedCatalogOverrideCriteria = useMemo(
        () => normalizeCatalogOverrideCriteria({ effectiveSubType, criteria: catalogOverrideCriteria }),
        [effectiveSubType, catalogOverrideCriteria]
    );

    const isCatalogOverrideHydrated = useMemo(
        () => isCatalogOverrideBaselineReady({ effectiveSubType, criteria: catalogOverrideCriteria }),
        [effectiveSubType, catalogOverrideCriteria]
    );

    const isCatalogOverrideMateriallyChanged = useMemo(
        () => hasMaterialCatalogOverrideChange(catalogOverrideBaseline, normalizedCatalogOverrideCriteria),
        [catalogOverrideBaseline, normalizedCatalogOverrideCriteria]
    );

    const isCatalogSearchDisabled = useMemo(() => (
        !isCatalogOverrideMandatorySelectionValid
        || isCatalogOverrideBaselineCapturePending
        || !catalogOverrideBaseline
        || !isCatalogOverrideHydrated
        || !isCatalogOverrideMateriallyChanged
    ), [
        isCatalogOverrideMandatorySelectionValid,
        isCatalogOverrideBaselineCapturePending,
        catalogOverrideBaseline,
        isCatalogOverrideHydrated,
        isCatalogOverrideMateriallyChanged,
    ]);

    // Builds search payload and dispatches catalog API based on order sub-type
    const SearchedCatalog = () => {
        if (isCatalogSearchDisabled) return;
        if (isProductionVehicle || isManagementVehicle) {
            if (!catalogOverrideSubTypeId) return;
            // PV/MV: send numeric filter IDs (API expects VehicleFilterRequest)
            const filterDropdownIds = [
                catalogOverrideCriteria.upfitOption?.value,
                catalogOverrideCriteria.snowSetup?.value,
                catalogOverrideCriteria.vehicle?.value,
                catalogOverrideCriteria.vehicleCapacity?.value,
                catalogOverrideCriteria.noOfDoors?.value,
                catalogOverrideCriteria.driveTrain?.value,
                catalogOverrideCriteria.fuelType?.value,
            ]
                .filter((v: any) => v !== null && v !== undefined && v !== "" && Number(v) > 0)
                .map((v: any) => Number(v));

            const body = {
                subTypeId: Number(catalogOverrideSubTypeId),
                filterDropdownIds,
                businessRoleTitleId:
                    isManagementVehicle && catalogOverrideCriteria.driverTitle?.value != null && Number(catalogOverrideCriteria.driverTitle.value) > 0
                        ? Number(catalogOverrideCriteria.driverTitle.value)
                        : null,
            };
            dispatch(getCatalogItemDetails(body, fleetRequestDetailId));
        } else if (isManagedEquipment) {
            // ME: numeric IDs payload for assets/managedequipment/catalogitems
            const body = {
                filterDropdownIds: Object.values(catalogOverrideCriteria.managedEquipFields)
                    .filter((v: any) => v?.value != null)
                    .map((v: any) => Number(v.value)),
                subTypeId: Number(catalogOverrideCriteria.equipmentType?.value),
            };
            dispatch(getManagedEquipmentItemDetails(body, fleetRequestDetailId));
        }
        setIsSearched(true);
    };

    useEffect(() => {
        dispatchPurchaseTypeDropdown();
        dispatchRegisteredDropdown();
    }, []);

    // Copy PV/MV catalog results from Redux into local state after Search
    useEffect(() => {
        if (
            isSearched &&
            (isProductionVehicle || isManagementVehicle) &&
            pvMvCatalogDetails &&
            fleetRequestDetailId != null &&
            Number(pvMvCatalogFleetRequestDetailId) === fleetRequestDetailId
        ) {
            const rows = Array.isArray(pvMvCatalogDetails) ? pvMvCatalogDetails : [];
            setCatalogGridData(rows.filter((x: any) => x?.assetModelIsActive === true));
        }
    }, [pvMvCatalogDetails, pvMvCatalogFleetRequestDetailId, isSearched, fleetRequestDetailId]);

    // Copy ME catalog results from Redux into local state after Search
    useEffect(() => {
        if (
            isSearched &&
            isManagedEquipment &&
            meCatalogDetails &&
            fleetRequestDetailId != null &&
            Number(meCatalogFleetRequestDetailId) === fleetRequestDetailId
        ) {
            const rows = Array.isArray(meCatalogDetails) ? meCatalogDetails : [];
            setCatalogGridData(rows.filter((x: any) => x?.assetModelIsActive === true));
        }
    }, [meCatalogDetails, meCatalogFleetRequestDetailId, isSearched, fleetRequestDetailId]);

  useEffect(()=>{
        setIsLicensedTitle(props?.purchaseOrderStepperData?.isLicensedTitled)
    }, [props?.purchaseOrderStepperData?.isLicensedTitled])

    useEffect(() => {
        if (!isCatalogOverrideEligible) {
            setIsCatalogOverrideEnabled(false);
            setShowCatalogOverrideSection(false);
        }
    }, [isCatalogOverrideEligible]);

    useEffect(() => {
        if (props?.purchaseOrderStepperData?.assetSourcing !== "CIP/Bulk Order") return;
        if (
            !isCatalogOverrideEnabled &&
            !showCatalogOverrideSection &&
            !props?.purchaseOrderStepperData?.catalogOverrideReason
        ) {
            return;
        }
        setIsCatalogOverrideEnabled(false);
        setShowCatalogOverrideSection(false);
        setCatalogOverridePopupcontent((prev: any) => (prev ? { ...prev, isDialogVisible: false } : prev));
        dispatchStepperData({ ...props?.purchaseOrderStepperData, catalogOverrideReason: '' });
    }, [
        props?.purchaseOrderStepperData?.assetSourcing,
        props?.purchaseOrderStepperData?.catalogOverrideReason,
        props?.purchaseOrderStepperData,
        isCatalogOverrideEnabled,
        showCatalogOverrideSection,
    ]);

    useEffect(() => {
        if (catalogSpecificationList?.response?.length && props.purchaseOrderStepperData?.fleetRequestDetailId === catalogSpecificationList?.fleetId) {
            const catalogSpecification = catalogSpecificationList.response[0]?.map((item: any) => {
                let label = item?.description
                return { ...item, label, value: item.assetModelId }
            })
            dispatchStepperData({ ...props?.purchaseOrderStepperData, catalogSpecification })
        }
    }, [catalogSpecificationList])

    /**
     * Triggers catalog override dropdown loading when the criteria section opens,
     * and resets all override dropdown state when it closes.
     * For Managed Equipment, uses the parent order request type ID (not sub-type ID)
     * from the global requisitionTypeList to load the correct equipment type list.
     */
    useEffect(() => {
        if (!showCatalogOverrideSection) {
            setCatalogOverrideCriteria(initialCatalogOverrideCriteria);
            setCatalogOverrideDropDownValues(initialCatalogOverrideDropDownValues);
            setCatalogOverrideBaseline(null);
            setIsCatalogOverrideBaselineCapturePending(false);
            setIsManagedEquipmentPrefillComplete(false);
            // Clear local search results when the catalog override section is closed
            setCatalogGridData([]);
            setIsSearched(false);
            setPendingCatalogCompareAssetModelId(null);
            setSelectedCatalogCompareItem({});
            preFillIdsRef.current = {};
            isPvInitialPrefillRef.current = true;
            isMvInitialPrefillRef.current = true;
            isMeInitialPrefillRef.current = true;
            dispatch(setRequistionDropDown([]));
            dispatch(setManagedEquipmentDropDown([]));
            dispatch(setCatalogItemByAssetModelId({}));
            return;
        }

        if (isProductionVehicle) {
            if (!catalogOverrideSubTypeId) return;
            isPvInitialPrefillRef.current = true;
            setIsCatalogOverrideBaselineCapturePending(true);
            dispatch(getRequistionDropDown({
                subTypeId: catalogOverrideSubTypeId,
                childAttributeName: AttributeName.UPFIT_OPTION,
                isProductionVehicle: true,
                fleetRequestDetailId: instanceFleetRequestDetailId,
            }));
        } else if (isManagementVehicle) {
            if (!catalogOverrideSubTypeId) return;
            isMvInitialPrefillRef.current = true;
            setIsCatalogOverrideBaselineCapturePending(true);
            dispatch(getRequistionDropDown({
                subTypeId: catalogOverrideSubTypeId,
                childAttributeName: AttributeName.DRIVER_TITLE,
                isProductionVehicle: false,
                fleetRequestDetailId: instanceFleetRequestDetailId,
            }));
        } else if (isManagedEquipment) {
            isMeInitialPrefillRef.current = true;
            setIsCatalogOverrideBaselineCapturePending(true);
            setIsManagedEquipmentPrefillComplete(false);
            // The getEquipmentType endpoint requires the parent order request type ID,
            // not the equipment sub-type ID. Find "Managed Equipment" in the global
            // requisitionTypeList to get the correct ID.
            const managedEquipType = requisitionTypeList?.find(
                (t: any) => t.orderRequestType === CONSTANTS.MANAGED_EQUIPMENT
            );
            const managedEquipTypeId = managedEquipType?.orderRequestTypeId;
            if (managedEquipTypeId) {
                dispatchEquipmentType(managedEquipTypeId);
            } else {
                // requisitionTypeList not loaded yet — fetch it; useEffect will re-trigger once loaded
                dispatch(getAssetType());
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showCatalogOverrideSection, requisitionTypeList]);

    useEffect(() => {
        if (!showCatalogOverrideSection || !isCatalogOverrideBaselineCapturePending) return;
        if (!isCatalogOverrideHydrated) return;
        if (isManagedEquipment && !isManagedEquipmentPrefillComplete) return;
        if (catalogOverrideBaseline) return;

        setCatalogOverrideBaseline(normalizedCatalogOverrideCriteria);
        setIsCatalogOverrideBaselineCapturePending(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        showCatalogOverrideSection,
        isCatalogOverrideBaselineCapturePending,
        isCatalogOverrideHydrated,
        isManagedEquipment,
        isManagedEquipmentPrefillComplete,
        normalizedCatalogOverrideCriteria,
        catalogOverrideBaseline,
    ]);

    /**
     * Processes the requisitionDropDown API response for Production Vehicle and
     * Management Vehicle cascading dropdowns.
     * On initial load, auto-selects the saved itemDetails values and cascades
     * to the next dropdown automatically (mirrors editRequestDetails pattern from
     * ProductionVehicle-Container). Uses preFillIdsRef to pass IDs between cascade
     * steps without relying on async state updates.
     */
    useEffect(() => {
        if (!showCatalogOverrideSection) return;
        if (!requisitionDropDown?.hasOwnProperty('response')) return;
        if (instanceFleetRequestDetailId && requisitionDropDown.fleetRequestDetailId !== instanceFleetRequestDetailId) return;

        const dropDownTemp = requisitionDropDown?.response?.map((item: any) => ({
            text: item.text,
            value: item.value,
            label: item.text,
            key: item?.price ?? '',
            showVehicleCapacity: item.selected ?? false,
        }));

        const { childAttributeName } = requisitionDropDown;
        const itemDetails = props?.itemDetails;
        const isVehicleAutoPrefillEnabled =
            (isProductionVehicle && isPvInitialPrefillRef.current) ||
            (isManagementVehicle && isMvInitialPrefillRef.current);

        /** Finds a pre-selected option by matching the saved display text from itemDetails. */
        const findPreSelected = (list: any[], savedText: string | null | undefined) =>
            savedText ? (list?.find((o: any) => o.text === savedText) ?? null) : null;

        if (childAttributeName === AttributeName.UPFIT_OPTION) {
            const preSelected = findPreSelected(dropDownTemp, itemDetails?.upfitOption);
            setCatalogOverrideDropDownValues((prev: any) => ({ ...prev, upfitOptionList: dropDownTemp ?? [] }));
            if (preSelected && isVehicleAutoPrefillEnabled) {
                preFillIdsRef.current.upfitOptionId = preSelected.value;
                setCatalogOverrideCriteria((prev: any) => ({ ...prev, upfitOption: preSelected }));
                dispatch(getRequistionDropDown({
                    subTypeId: catalogOverrideSubTypeId,
                    childAttributeName: AttributeName.SNOW_SETUP,
                    upFit: preSelected.value,
                    isProductionVehicle: true,
                    fleetRequestDetailId: instanceFleetRequestDetailId,
                }));
            }
        } else if (childAttributeName === AttributeName.SNOW_SETUP) {
            const preSelected = findPreSelected(dropDownTemp, itemDetails?.snowSetup);
            setCatalogOverrideDropDownValues((prev: any) => ({ ...prev, snowSetupList: dropDownTemp ?? [] }));
            if (preSelected && isVehicleAutoPrefillEnabled) {
                preFillIdsRef.current.snowSetupId = preSelected.value;
                setCatalogOverrideCriteria((prev: any) => ({ ...prev, snowSetup: preSelected }));
                dispatch(getRequistionDropDown({
                    subTypeId: catalogOverrideSubTypeId,
                    childAttributeName: AttributeName.VEHICLE_TYPE,
                    upFit: preFillIdsRef.current.upfitOptionId,
                    snowSetup: preSelected.value,
                    isProductionVehicle: true,
                    fleetRequestDetailId: instanceFleetRequestDetailId,
                }));
            }
        } else if (childAttributeName === AttributeName.VEHICLE_TYPE) {
            const vehicleText = itemDetails?.vechileType ?? itemDetails?.vehicleType;
            const preSelected = findPreSelected(dropDownTemp, vehicleText);
            setCatalogOverrideDropDownValues((prev: any) => ({ ...prev, vehicleList: dropDownTemp ?? [] }));
            if (preSelected && isVehicleAutoPrefillEnabled) {
                preFillIdsRef.current.vehicleId = preSelected.value;
                setCatalogOverrideCriteria((prev: any) => ({ ...prev, vehicle: preSelected }));
                if (isManagementVehicle) {
                    // MV cascade: Vehicle → Drive Train (matches creation flow)
                    dispatch(getRequistionDropDown({
                        subTypeId: catalogOverrideSubTypeId,
                        childAttributeName: AttributeName.DRIVE_TRAIN,
                        driverTitle: preFillIdsRef.current.driverTitleId,
                        vehicle: preSelected.value,
                        isProductionVehicle: false,
                        isVehicleCapacity: false,
                        fleetRequestDetailId: instanceFleetRequestDetailId,
                    }));
                } else {
                    // PV cascade: Vehicle → Truck Size (if applicable) or No of Doors
                    const showVehicleCapacity = preSelected.showVehicleCapacity ?? false;
                    preFillIdsRef.current.showVehicleCapacity = showVehicleCapacity;
                    dispatch(getRequistionDropDown({
                        subTypeId: catalogOverrideSubTypeId,
                        childAttributeName: showVehicleCapacity ? AttributeName.TRUCK_SIZE : AttributeName.NO_OF_DOORS,
                        upFit: preFillIdsRef.current.upfitOptionId,
                        snowSetup: preFillIdsRef.current.snowSetupId,
                        vehicle: preSelected.value,
                        isProductionVehicle: true,
                        isVehicleCapacity: showVehicleCapacity,
                        fleetRequestDetailId: instanceFleetRequestDetailId,
                    }));
                }
            }
        } else if (childAttributeName === AttributeName.TRUCK_SIZE) {
            const preSelected = findPreSelected(dropDownTemp, itemDetails?.vehicleCapacity);
            setCatalogOverrideDropDownValues((prev: any) => ({ ...prev, vehicleCapacityList: dropDownTemp ?? [] }));
            if (preSelected && isVehicleAutoPrefillEnabled) {
                preFillIdsRef.current.vehicleCapacityId = preSelected.value;
                setCatalogOverrideCriteria((prev: any) => ({ ...prev, vehicleCapacity: preSelected }));
                dispatch(getRequistionDropDown({
                    subTypeId: catalogOverrideSubTypeId,
                    childAttributeName: AttributeName.NO_OF_DOORS,
                    upFit: preFillIdsRef.current.upfitOptionId,
                    snowSetup: preFillIdsRef.current.snowSetupId,
                    vehicle: preFillIdsRef.current.vehicleId,
                    isProductionVehicle: true,
                    isVehicleCapacity: true,
                    vehicleCapacity: preSelected.value,
                    fleetRequestDetailId: instanceFleetRequestDetailId,
                }));
            }
        } else if (childAttributeName === AttributeName.NO_OF_DOORS) {
            const preSelected = findPreSelected(dropDownTemp, itemDetails?.noOfDoors);
            setCatalogOverrideDropDownValues((prev: any) => ({ ...prev, noOfDoorsList: dropDownTemp ?? [] }));
            if (preSelected && isVehicleAutoPrefillEnabled) {
                preFillIdsRef.current.noOfDoorsId = preSelected.value;
                setCatalogOverrideCriteria((prev: any) => ({ ...prev, noOfDoors: preSelected }));
                dispatch(getRequistionDropDown({
                    subTypeId: catalogOverrideSubTypeId,
                    childAttributeName: AttributeName.DRIVE_TRAIN,
                    upFit: preFillIdsRef.current.upfitOptionId,
                    snowSetup: preFillIdsRef.current.snowSetupId,
                    vehicle: preFillIdsRef.current.vehicleId,
                    isProductionVehicle: isProductionVehicle,
                    isVehicleCapacity: preFillIdsRef.current.showVehicleCapacity ?? false,
                    vehicleCapacity: preFillIdsRef.current.vehicleCapacityId,
                    noOfDoors: preSelected.value,
                    driverTitle: preFillIdsRef.current.driverTitleId,
                    fleetRequestDetailId: instanceFleetRequestDetailId,
                }));
            }
        } else if (childAttributeName === AttributeName.DRIVE_TRAIN) {
            const preSelected = findPreSelected(dropDownTemp, itemDetails?.driveTrain);
            setCatalogOverrideDropDownValues((prev: any) => ({ ...prev, driveTrainList: dropDownTemp ?? [] }));
            if (preSelected && isVehicleAutoPrefillEnabled) {
                preFillIdsRef.current.driveTrainId = preSelected.value;
                setCatalogOverrideCriteria((prev: any) => ({ ...prev, driveTrain: preSelected }));
                dispatch(getRequistionDropDown({
                    subTypeId: catalogOverrideSubTypeId,
                    childAttributeName: AttributeName.FUEL_TYPE,
                    upFit: preFillIdsRef.current.upfitOptionId,
                    snowSetup: preFillIdsRef.current.snowSetupId,
                    vehicle: preFillIdsRef.current.vehicleId,
                    isProductionVehicle: isProductionVehicle,
                    isVehicleCapacity: preFillIdsRef.current.showVehicleCapacity ?? false,
                    vehicleCapacity: preFillIdsRef.current.vehicleCapacityId,
                    noOfDoors: preFillIdsRef.current.noOfDoorsId,
                    driverTitle: preFillIdsRef.current.driverTitleId,
                    driveTrain: preSelected.value,
                    fleetRequestDetailId: instanceFleetRequestDetailId,
                }));
            }
        } else if (childAttributeName === AttributeName.FUEL_TYPE) {
            const withSelectOption = [{ value: null, label: 'Select', text: 'Select' }, ...(dropDownTemp ?? [])];
            const preSelected = findPreSelected(dropDownTemp, itemDetails?.fuelType);
            setCatalogOverrideDropDownValues((prev: any) => ({ ...prev, fuelTypeList: withSelectOption }));
            if (preSelected && isVehicleAutoPrefillEnabled) {
                setCatalogOverrideCriteria((prev: any) => ({ ...prev, fuelType: preSelected }));
            }
        } else if (childAttributeName === AttributeName.DRIVER_TITLE) {
            const preSelected = findPreSelected(dropDownTemp, itemDetails?.driverTitle);
            setCatalogOverrideDropDownValues((prev: any) => ({ ...prev, driverTitleList: dropDownTemp ?? [] }));
            if (preSelected && isVehicleAutoPrefillEnabled) {
                preFillIdsRef.current.driverTitleId = preSelected.value;
                setCatalogOverrideCriteria((prev: any) => ({ ...prev, driverTitle: preSelected }));
                dispatch(getRequistionDropDown({
                    subTypeId: catalogOverrideSubTypeId,
                    childAttributeName: AttributeName.VEHICLE_TYPE,
                    driverTitle: preSelected.value,
                    isProductionVehicle: false,
                    fleetRequestDetailId: instanceFleetRequestDetailId,
                }));
            }
        }

        dispatch(setRequistionDropDown([]));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [requisitionDropDown]);

    /**
     * Processes the Equipment Type list for Managed Equipment catalog override.
     * Pre-fills the equipment type dropdown with the item's current equipment type.
     */
    useEffect(() => {
        if (!showCatalogOverrideSection || !isManagedEquipment) return;
        if (equipmentDropdown?.length > 0) {
            const equipmentTypeList = equipmentDropdown.map((item: any) => ({
                text: item.text,
                value: item.value,
                label: item.text,
                key: item.value,
            }));
            setCatalogOverrideDropDownValues((prev: any) => ({ ...prev, equipmentTypeList }));

            // Pre-fill the equipment type from the item's current sub-type.
            // Use Number() coercion to handle potential string/number type mismatch from API.
            if (catalogOverrideSubTypeId && isMeInitialPrefillRef.current) {
                const preSelected = equipmentTypeList.find(
                    (e: any) => Number(e.value) === Number(catalogOverrideSubTypeId)
                );
                if (preSelected) {
                    setCatalogOverrideCriteria((prev: any) => ({ ...prev, equipmentType: preSelected }));
                    dispatch(getManagedEquipmentDropDown(preSelected.value));
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [equipmentDropdown]);

    /**
     * Maps API managedEquipmentDropDown response to named per-field lists —
     * same dropdownName→fieldKey mapping used by all order-creation sub-containers
     * (Mower-Container, Snow-Container, Trailer-Container, etc.).
     * Pre-fills each field from saved itemDetails by numeric ID match (creation edit-mode pattern).
     */
    useEffect(() => {
        if (!showCatalogOverrideSection || !isManagedEquipment) return;
        if (!managedEquipmentDropDown?.length) return;

        // Mirror requisition create-flow behavior: optional ME sub-filters always include a top "Select <Field>" option.
        const toOptions = (list: any[], dropdownName: string): any[] => {
            const mapped = (list ?? []).map((val: any) => ({
                text: val.text,
                value: val.value,
                label: val.text,
                key: val.value,
            }));
            const hasSelectOption = mapped.some(
                (o: any) => o?.value == null && String(o?.label ?? o?.text ?? "").toLowerCase().startsWith("select")
            );
            if (hasSelectOption) return mapped;
            const selectLabel = `Select ${dropdownName}`;
            return [{ text: selectLabel, value: null, label: selectLabel, key: null }, ...mapped];
        };

        // Map each dropdownName to the named field key used in state and itemDetails
        const updates: Record<string, any[]> = {};
        managedEquipmentDropDown.forEach((item: any) => {
            const opts = toOptions(item.dropdownList, item.dropdownName);
            switch (item.dropdownName) {
        case 'Manufacturer':       updates.manufacturer = opts; break;
        case 'Category':           updates.category = opts; break;
                case 'State Availability': updates.stateAvailability = opts; break;
        case 'Program Status':     updates.programStatus = opts; break;
        case 'Annual Hours':       updates.annualHours = opts; break;
        case 'Deck Size':          updates.deckSize = opts; break;
        case 'Deck Type':          updates.deckType = opts; break;
        case 'Autonomous':         updates.autonomous = opts; break;
        case 'Size':               updates.size = opts; break;
        case 'Type':               updates.type = opts; break;
        case 'Style':              updates.style = opts; break;
        case 'Length':             updates.length = opts; break;
        case 'Fuel Tank':          updates.fuelTank = opts; break;
        case 'Charging Station':   updates.chargingStation = opts; break;
        case 'Seating Capacity':   updates.seatingCapacity = opts; break;
        case 'Enclosed Cab':       updates.enclosedCab = opts; break;
        case 'Capacity':           updates.capacity = opts; break;
        case 'Equipment Type':     updates.treeCareEquipmentType = opts; break; // TreeCare sub-type
        case 'Horse Power':        updates.horsePower = opts; break;
        case 'Fuel Type':          updates.fuelType = opts; break;
            }
        });
        setCatalogOverrideDropDownValues((prev: any) => ({ ...prev, ...updates }));

        // Pre-fill from Managed Equipment criteria returned by fleet item details API.
        const itemDetails = props?.itemDetails;
        const managedEquipmentCriteriaIds = itemDetails?.managedEquipmentCriteriaIds ?? {};
        const preFilledFields: Record<string, any> = {};
        Object.entries(updates).forEach(([fieldName, options]) => {
            const matchedSearchCriteriaKey = Object.entries(meSearchCriteriaToFieldKeyMap)
                .find(([, mappedFieldName]) => mappedFieldName === fieldName)?.[0];
            const savedValue = matchedSearchCriteriaKey ? managedEquipmentCriteriaIds?.[matchedSearchCriteriaKey] : null;
            if (savedValue != null) {
                const matched =
                    options.find((o: any) => Number(o.value) === Number(savedValue)) ??
                    null;
                if (matched) preFilledFields[fieldName] = matched;
            }
        });
        if (Object.keys(preFilledFields).length > 0 && isMeInitialPrefillRef.current) {
            setCatalogOverrideCriteria((prev: any) => ({
                ...prev,
                managedEquipFields: { ...prev.managedEquipFields, ...preFilledFields },
            }));
        }
        if (isMeInitialPrefillRef.current) setIsManagedEquipmentPrefillComplete(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [managedEquipmentDropDown]);

    /**
     * Handles dropdown changes in the catalog override criteria form for
     * Production Vehicle and Management Vehicle with cascading API calls.
     * Each selection triggers the next dropdown in the cascade to load.
     */
    const handleCatalogOverrideDropdownChange = (fieldName: string, val: any) => {
        if (isProductionVehicle) {
            isPvInitialPrefillRef.current = false;
            if (fieldName === 'upfitOption') {
                setCatalogOverrideCriteria((prev: any) => ({
                    ...prev, upfitOption: val, snowSetup: null, vehicle: null, vehicleCapacity: null, noOfDoors: null, driveTrain: null, fuelType: null,
                }));
                setCatalogOverrideDropDownValues((prev: any) => ({
                    ...prev, snowSetupList: [], vehicleList: [], vehicleCapacityList: [], noOfDoorsList: [], driveTrainList: [], fuelTypeList: [],
                }));
                dispatch(getRequistionDropDown({
                    subTypeId: catalogOverrideSubTypeId,
                    childAttributeName: AttributeName.SNOW_SETUP,
                    upFit: val?.value,
                    isProductionVehicle: true,
                    fleetRequestDetailId: instanceFleetRequestDetailId,
                }));
            } else if (fieldName === 'snowSetup') {
                setCatalogOverrideCriteria((prev: any) => ({
                    ...prev, snowSetup: val, vehicle: null, vehicleCapacity: null, noOfDoors: null, driveTrain: null, fuelType: null,
                }));
                setCatalogOverrideDropDownValues((prev: any) => ({
                    ...prev, vehicleList: [], vehicleCapacityList: [], noOfDoorsList: [], driveTrainList: [], fuelTypeList: [],
                }));
                dispatch(getRequistionDropDown({
                    subTypeId: catalogOverrideSubTypeId,
                    childAttributeName: AttributeName.VEHICLE_TYPE,
                    upFit: catalogOverrideCriteria.upfitOption?.value,
                    snowSetup: val?.value,
                    isProductionVehicle: true,
                    fleetRequestDetailId: instanceFleetRequestDetailId,
                }));
            } else if (fieldName === 'vehicle') {
                const showVehicleCapacity = val?.showVehicleCapacity ?? false;
                setCatalogOverrideCriteria((prev: any) => ({
                    ...prev, vehicle: val, vehicleCapacity: null, noOfDoors: null, driveTrain: null, fuelType: null,
                }));
                setCatalogOverrideDropDownValues((prev: any) => ({
                    ...prev, vehicleCapacityList: [], noOfDoorsList: [], driveTrainList: [], fuelTypeList: [],
                }));
                dispatch(getRequistionDropDown({
                    subTypeId: catalogOverrideSubTypeId,
                    childAttributeName: showVehicleCapacity ? AttributeName.TRUCK_SIZE : AttributeName.NO_OF_DOORS,
                    upFit: catalogOverrideCriteria.upfitOption?.value,
                    snowSetup: catalogOverrideCriteria.snowSetup?.value,
                    vehicle: val?.value,
                    isProductionVehicle: true,
                    isVehicleCapacity: showVehicleCapacity,
                    fleetRequestDetailId: instanceFleetRequestDetailId,
                }));
            } else if (fieldName === 'vehicleCapacity') {
                setCatalogOverrideCriteria((prev: any) => ({
                    ...prev, vehicleCapacity: val, noOfDoors: null, driveTrain: null, fuelType: null,
                }));
                setCatalogOverrideDropDownValues((prev: any) => ({
                    ...prev, noOfDoorsList: [], driveTrainList: [], fuelTypeList: [],
                }));
                dispatch(getRequistionDropDown({
                    subTypeId: catalogOverrideSubTypeId,
                    childAttributeName: AttributeName.NO_OF_DOORS,
                    upFit: catalogOverrideCriteria.upfitOption?.value,
                    snowSetup: catalogOverrideCriteria.snowSetup?.value,
                    vehicle: catalogOverrideCriteria.vehicle?.value,
                    isProductionVehicle: true,
                    isVehicleCapacity: true,
                    vehicleCapacity: val?.value,
                    fleetRequestDetailId: instanceFleetRequestDetailId,
                }));
            } else if (fieldName === 'noOfDoors') {
                setCatalogOverrideCriteria((prev: any) => ({
                    ...prev, noOfDoors: val, driveTrain: null, fuelType: null,
                }));
                setCatalogOverrideDropDownValues((prev: any) => ({
                    ...prev, driveTrainList: [], fuelTypeList: [],
                }));
                dispatch(getRequistionDropDown({
                    subTypeId: catalogOverrideSubTypeId,
                    childAttributeName: AttributeName.DRIVE_TRAIN,
                    upFit: catalogOverrideCriteria.upfitOption?.value,
                    snowSetup: catalogOverrideCriteria.snowSetup?.value,
                    vehicle: catalogOverrideCriteria.vehicle?.value,
                    isProductionVehicle: true,
                    isVehicleCapacity: catalogOverrideCriteria.vehicle?.showVehicleCapacity ?? false,
                    vehicleCapacity: catalogOverrideCriteria.vehicleCapacity?.value,
                    noOfDoors: val?.value,
                    fleetRequestDetailId: instanceFleetRequestDetailId,
                }));
            } else if (fieldName === 'driveTrain') {
                setCatalogOverrideCriteria((prev: any) => ({
                    ...prev, driveTrain: val, fuelType: null,
                }));
                setCatalogOverrideDropDownValues((prev: any) => ({ ...prev, fuelTypeList: [] }));
                dispatch(getRequistionDropDown({
                    subTypeId: catalogOverrideSubTypeId,
                    childAttributeName: AttributeName.FUEL_TYPE,
                    driveTrain: val?.value,
                    upFit: catalogOverrideCriteria.upfitOption?.value,
                    snowSetup: catalogOverrideCriteria.snowSetup?.value,
                    vehicle: catalogOverrideCriteria.vehicle?.value,
                    isProductionVehicle: true,
                    isVehicleCapacity: catalogOverrideCriteria.vehicle?.showVehicleCapacity ?? false,
                    vehicleCapacity: catalogOverrideCriteria.vehicleCapacity?.value,
                    noOfDoors: catalogOverrideCriteria.noOfDoors?.value,
                    fleetRequestDetailId: instanceFleetRequestDetailId,
                }));
            } else {
                // Terminal field (fuelType) — just update criteria, no further cascade
                setCatalogOverrideCriteria((prev: any) => ({ ...prev, [fieldName]: val }));
            }
        } else if (isManagementVehicle) {
            isMvInitialPrefillRef.current = false;
            if (fieldName === 'driverTitle') {
                setCatalogOverrideCriteria((prev: any) => ({
                    ...prev, driverTitle: val, vehicle: null, driveTrain: null, fuelType: null,
                }));
                setCatalogOverrideDropDownValues((prev: any) => ({
                    ...prev, vehicleList: [], driveTrainList: [], fuelTypeList: [],
                }));
                dispatch(getRequistionDropDown({
                    subTypeId: catalogOverrideSubTypeId,
                    childAttributeName: AttributeName.VEHICLE_TYPE,
                    driverTitle: val?.value,
                    isProductionVehicle: false,
                    fleetRequestDetailId: instanceFleetRequestDetailId,
                }));
            } else if (fieldName === 'vehicle') {
                setCatalogOverrideCriteria((prev: any) => ({
                    ...prev, vehicle: val, driveTrain: null, fuelType: null,
                }));
                setCatalogOverrideDropDownValues((prev: any) => ({
                    ...prev, driveTrainList: [], fuelTypeList: [],
                }));
                dispatch(getRequistionDropDown({
                    subTypeId: catalogOverrideSubTypeId,
                    childAttributeName: AttributeName.DRIVE_TRAIN,
                    driverTitle: catalogOverrideCriteria.driverTitle?.value,
                    vehicle: val?.value,
                    isProductionVehicle: false,
                    fleetRequestDetailId: instanceFleetRequestDetailId,
                }));
            } else if (fieldName === 'driveTrain') {
                setCatalogOverrideCriteria((prev: any) => ({
                    ...prev, driveTrain: val, fuelType: null,
                }));
                setCatalogOverrideDropDownValues((prev: any) => ({ ...prev, fuelTypeList: [] }));
                dispatch(getRequistionDropDown({
                    subTypeId: catalogOverrideSubTypeId,
                    childAttributeName: AttributeName.FUEL_TYPE,
                    driverTitle: catalogOverrideCriteria.driverTitle?.value,
                    vehicle: catalogOverrideCriteria.vehicle?.value,
                    driveTrain: val?.value,
                    isProductionVehicle: false,
                    fleetRequestDetailId: instanceFleetRequestDetailId,
                }));
            } else {
                // Terminal field (fuelType) — just update criteria, no further cascade
                setCatalogOverrideCriteria((prev: any) => ({ ...prev, [fieldName]: val }));
            }
        } else {
            setCatalogOverrideCriteria((prev: any) => ({ ...prev, [fieldName]: val }));
        }
    };

    /**
     * Handles Equipment Type selection — resets all ME named sub-lists and fetches new sub-dropdowns.
     */
    const handleCatalogOverrideEquipmentTypeChange = (val: any) => {
        isMeInitialPrefillRef.current = false;
        setCatalogOverrideCriteria((prev: any) => ({
            ...prev,
            equipmentType: val,
            managedEquipFields: {},
        }));
        // Reset all named ME sub-dropdown lists when equipment type changes
        setCatalogOverrideDropDownValues((prev: any) => ({ ...prev, ...initialMENamedLists }));
        if (val?.value) {
            dispatch(getManagedEquipmentDropDown(val.value));
        }
    };

    /**
     * Unified ME sub-field change handler — signature matches all order-creation sub-container handlers
     * (e, item, name) so the same function is passed to every handler prop of each presentation component.
     */
    const handleManagedEquipSubFieldChange = (_e: any, item: any, name: string) => {
        isMeInitialPrefillRef.current = false;
        setCatalogOverrideCriteria((prev: any) => ({
            ...prev,
            managedEquipFields: { ...(prev.managedEquipFields ?? {}), [name]: item },
        }));
    };

    const getActiveRow = useSelector((state: any) => state.CustomerMyOrder.data);

    const togglePopup = () => {
        activeRow({ rowData: {} });
        setshowPoolPopup((prev) => !prev);
        if (!showPoolPopup) {
            dispatchPoolGridData(props?.itemDetails?.orderRequestSubTypeId ?? 0);
        }
    };


    const handleClickPick = () => {
        if (!getActiveRow.rowData.assetNo) {
            setAssetPoolError("Please choose asset from list !!");
            return;
        }
        if (getActiveRow.rowData.allocatedTo) {
            setAssetPoolError(
                "Selected asset is already been alloted. Please try with different asset !!"
            );
            return;
        }
        const orderTypeValue = orderType?.find((x: any) => x?.text === CONSTANTS?.ORDER_TYPE?.BAILMENT_POOL)
        const purchaseOrderData = {
            ...props?.purchaseOrderStepperData,
            assetNumber: getActiveRow.rowData.assetNo,
            assetSourcing: "CIP/Bulk Order",
            orderType: orderTypeValue?.text,
            orderTypeId: orderTypeValue?.value,
            isPurchaseDetailsSave: false,
            pocipDetails: {
                cipUnitNumber: getActiveRow.rowData.cipUnitNumber,
                isCIPOrder: getActiveRow.rowData.cipOrder,
                cipEqClass: getActiveRow.rowData.eqClass,
                cipManufac: getActiveRow.rowData.manufacturer,
                cipDesc: getActiveRow.rowData.description,
                cipModelYear: getActiveRow.rowData.year,
                cipgvw: getActiveRow.rowData.gvw,
                cipSerialNumber: getActiveRow.rowData.serialNo,
                cippoNumber: getActiveRow.rowData.po,
            },
            vinSerialMismatch: (() => {
                const existingVin = (props?.purchaseOrderStepperData?.vinSerial ?? '').trim();
                const cipSerial = (getActiveRow.rowData.serialNo ?? '').trim();
                const isMismatch = existingVin !== cipSerial;
                return isMismatch;
            })(),
            poVendorDetails: undefined,
            validationMessage: ""
        };
        props.setErrors({ assetNumber: false });
        dispatchStepperData({ ...purchaseOrderData, assetIsValid: undefined });
        props.setSkipVendorDetail(true);
        activeRow({ rowData: {} });
        togglePopup();
        setClickPoolBtn(true)
    };

    const handleClickRestore = () => {
        const orderTypeValue = orderType?.find((x: any) => x?.text === CONSTANTS?.ORDER_TYPE?.NA)
        const purchaseOrderData = {
            ...props?.purchaseOrderStepperData,
            assetNumber: "",
            pocipDetails: null,
            orderType: orderTypeValue?.text,
            orderTypeId: orderTypeValue?.value,
            assetSourcing: props.itemDetails?.isCIPOrder
                ? "Factory Bailment Order"
                : "Stock",
            poVendorDetails: undefined,
            isChangedAfterPoCreation: ((props?.purchaseOrderStepperData?.poNumber || check) && !props?.purchaseOrderStepperData?.createUniquePO && props?.purchaseOrderStepperData?.isCipPoolSaved) ? true : false,
            isPurchaseDetailsSave: false,
            description: (props?.purchaseOrderStepperData?.pocipDetails?.hasOwnProperty('cipUnitNumber') && props?.purchaseOrderStepperData?.orderRequestType !== CONSTANTS?.NON_STANDARD_EQUIPMENT && props?.purchaseOrderStepperData?.orderRequestType !== CONSTANTS?.MANAGED_EQUIPMENT) ? "" : props?.purchaseOrderStepperData?.description,
            descriptionId: (props?.purchaseOrderStepperData?.pocipDetails?.hasOwnProperty('cipUnitNumber') && props?.purchaseOrderStepperData?.orderRequestType !== CONSTANTS?.NON_STANDARD_EQUIPMENT && props?.purchaseOrderStepperData?.orderRequestType !== CONSTANTS?.MANAGED_EQUIPMENT) ? "" : props?.purchaseOrderStepperData?.descriptionId,
            pricePerUnit: (props?.purchaseOrderStepperData?.pocipDetails?.hasOwnProperty('cipUnitNumber') && props?.purchaseOrderStepperData?.orderRequestType !== CONSTANTS?.NON_STANDARD_EQUIPMENT && props?.purchaseOrderStepperData?.orderRequestType !== CONSTANTS?.MANAGED_EQUIPMENT) ? "0.00" : props?.purchaseOrderStepperData?.pricePerUnit,
            assetModelId: (props?.purchaseOrderStepperData?.pocipDetails?.hasOwnProperty('cipUnitNumber') && props?.purchaseOrderStepperData?.orderRequestType !== CONSTANTS?.NON_STANDARD_EQUIPMENT && props?.purchaseOrderStepperData?.orderRequestType !== CONSTANTS?.MANAGED_EQUIPMENT) ? null : props?.purchaseOrderStepperData?.assetModelId,
        };
        activeRow({ rowData: {} });
        props.setErrors({ assetNumber: false });
        dispatchStepperData(purchaseOrderData);
        props.setSkipVendorDetail(false);
    }

    const unitPriceFormat = (item: any) => {
        let purchaseOrderData = {
            ...props?.purchaseOrderStepperData,
        };
        purchaseOrderData.pricePerUnit = formatPrice(item, 2);
        dispatchStepperData(purchaseOrderData);
    };
    const onChangeDescription = (selectedItem: any) => {
        let purchaseOrderData = {
            ...props?.purchaseOrderStepperData,
        };
        purchaseOrderData.descriptionId = { ...selectedItem, label: selectedItem.description, value: selectedItem.assetModelId };
        purchaseOrderData.pricePerUnit = formatPrice(selectedItem?.price, 2)
        purchaseOrderData.description = selectedItem?.description
        purchaseOrderData.poDescription1 = selectedItem?.podesc1
        purchaseOrderData.poDescription2 = selectedItem?.podesc2
        purchaseOrderData.make = selectedItem?.make
        purchaseOrderData.model = selectedItem?.model
        purchaseOrderData.assetModelId = selectedItem?.assetModelId
        purchaseOrderData.isPurchaseDetailsSave = false
        const error = Validation.ValidatePricePerUnit(purchaseOrderData, purchaseOrderData);
    error?.pricePerUnitError?.length > 0 ? props.setErrors({ ...props.errors, descriptionError: "", pricePerUnit: true }) : props.setErrors({ ...props.errors,  descriptionError: "", pricePerUnit: false });
        dispatchStepperData(purchaseOrderData);
    }
    const onClick = (e: any) => {
        e.stopPropagation();
    }

    /**
     * Handles the "Catalog Override?" toggle change.
     * Turning ON opens the reason popup; turning OFF resets all override state.
     */
    const handleCatalogOverrideToggleChange = (_event: any, isEnabled?: boolean) => {
        if (!isCatalogOverrideEligible) {
            setIsCatalogOverrideEnabled(false);
            setShowCatalogOverrideSection(false);
            return;
        }

        if (isEnabled) {
            setIsCatalogOverrideEnabled(true);
            setCatalogOverridePopupcontent({
                titleImg: ConfirmationBee,
                title: "Catalog Override Reason",
                subtextcontent: "",
                isDialogVisible: true,
                isCommentboxVisible: true,
                isCommentBoxRequire: true,
                outlineBtnText: "Cancel",
                primaryBtnText: "OK",
                comment: "",
                isPrimaryBtnDisabled: false,
                isCompletedReportVisible: false,
                isSingleConfirmationBtn: false,
                isAdditionalConfirmationBtn: false,
                isTitleWarning: false,
                actionby: null,
                value: null,
                popupPrimarybtnOnclick: (_nav: any, comment: string) => {
                    dispatchStepperData({ ...props?.purchaseOrderStepperData, catalogOverrideReason: comment });
                    setCatalogOverridePopupcontent((prev: any) => ({ ...prev, isDialogVisible: false }));
                    setShowCatalogOverrideSection(true);
                },
            });
        } else {
            setIsCatalogOverrideEnabled(false);
            setShowCatalogOverrideSection(false);
            dispatchStepperData({ ...props?.purchaseOrderStepperData, catalogOverrideReason: '' });
        }
    };

    /**
     * Dismisses the catalog override reason popup and rolls back the toggle
     * since the user cancelled without confirming a reason.
     */
    const hideCatalogOverrideDialog = () => {
        setCatalogOverridePopupcontent((prev: any) => ({ ...prev, isDialogVisible: false }));
        setIsCatalogOverrideEnabled(false);
    };

    const handleSelectCatalogItem = (assetModelId: any) => {
        setPendingCatalogCompareAssetModelId(assetModelId);
        setSelectedCatalogCompareItem({});
        dispatch(setCatalogItemByAssetModelId({}));
        dispatch(getCatalogItemByAssetModelId(assetModelId));
    };

    const handleCloseCatalogComparePopup = () => {
        setShowCatalogComparePopup(false);
        setPendingCatalogCompareAssetModelId(null);
        setSelectedCatalogCompareItem({});
        dispatch(setCatalogItemByAssetModelId({}));
    };

    useEffect(() => {
        if (!showCatalogOverrideSection) return;
        if (
            pendingCatalogCompareAssetModelId &&
            catalogItemByAssetModelId?.assetModelId === pendingCatalogCompareAssetModelId
        ) {
            setSelectedCatalogCompareItem(catalogItemByAssetModelId);
            setShowCatalogComparePopup(true);
            setPendingCatalogCompareAssetModelId(null);
        }
    }, [catalogItemByAssetModelId, showCatalogOverrideSection, pendingCatalogCompareAssetModelId]);

    const toFiniteNumber = (value: any) => {
        const numeric = value === null || value === undefined || value === "" ? 0 : Number(value);
        return Number.isFinite(numeric) ? numeric : 0;
    };

    const originalBudgetingPrice = toFiniteNumber(
        props?.itemDetails?.orderDetailPrice ??
        props?.purchaseOrderStepperData?.pricePerUnit
    );

    const newBudgetingPrice = toFiniteNumber(
        selectedCatalogCompareItem?.budgetInfo?.budgetingPrice
    );

    const priceDifferencePercent =
        originalBudgetingPrice > 0
            ? (newBudgetingPrice - originalBudgetingPrice) / originalBudgetingPrice
            : 0;

    const isPriceThresholdViolation =
        originalBudgetingPrice > 0 && priceDifferencePercent > 0.1;

    const [catalogOverrideResultPopup, setCatalogOverrideResultPopup] = useState<any>({ isDialogVisible: false });

    /**
     * Builds the CatalogOverrideVM payload and dispatches the save action.
     * Collects vehicle/managedEquipment criteria IDs based on order sub-type.
     */
    const handleSaveCatalogOverride = () => {
        const fleetRequestDetailId = props?.purchaseOrderStepperData?.fleetRequestDetailId;
        if (!fleetRequestDetailId) return;
        const reason = props?.purchaseOrderStepperData?.catalogOverrideReason ?? '';
        const savedBy = currentUser?.currentUserName ?? '';

        const payload: any = {
            fleetRequestDetailId,
            reason,
            savedBy,
            NewAssetModelId: selectedCatalogCompareItem?.assetModelId ?? null,
        };

        if (isProductionVehicle || isManagementVehicle) {
            payload.vehicle = {
                driverTitleId: catalogOverrideCriteria.driverTitle?.value ?? null,
                driverTitle: catalogOverrideCriteria.driverTitle?.text ?? null,
                vehicleTypeId: catalogOverrideCriteria.vehicle?.value ?? null,
                vehicleCapacityId: catalogOverrideCriteria.vehicleCapacity?.value ?? null,
                noOfDoorsId: catalogOverrideCriteria.noOfDoors?.value ?? null,
                driveTrainId: catalogOverrideCriteria.driveTrain?.value ?? null,
                upfitOptionId: catalogOverrideCriteria.upfitOption?.value ?? null,
                fuelTypeId: catalogOverrideCriteria.fuelType?.value ?? null,
                snowSetupId: catalogOverrideCriteria.snowSetup?.value ?? null,
            };
        } else if (isManagedEquipment) {
            const meFields = catalogOverrideCriteria.managedEquipFields ?? {};
            payload.managedEquipment = {
                categoryId: meFields.category?.value ?? null,
                manufacturerId: meFields.manufacturer?.value ?? null,
                stateAvailabilityId: meFields.stateAvailability?.value ?? null,
                programStatusId: meFields.programStatus?.value ?? null,
                annualHoursId: meFields.annualHours?.value ?? null,
                deckSizeId: meFields.deckSize?.value ?? null,
                deckTypeId: meFields.deckType?.value ?? null,
                autonomousId: meFields.autonomous?.value ?? null,
                sizeId: meFields.size?.value ?? null,
                typeId: meFields.type?.value ?? null,
                parentVehicleId: null,
                styleId: meFields.style?.value ?? null,
                lengthId: meFields.length?.value ?? null,
                fuelTankId: meFields.fuelTank?.value ?? null,
                chargingStationId: meFields.chargingStation?.value ?? null,
                treeCareEquipmentTypeId: meFields.treeCareEquipmentType?.value ?? null,
                horsePowerId: meFields.horsePower?.value ?? null,
                fuelTypeId: meFields.fuelType?.value ?? null,
                seatingCapacityId: meFields.seatingCapacity?.value ?? null,
                enclosedCabId: meFields.enclosedCab?.value ?? null,
                capacityId: meFields.capacity?.value ?? null,
            };
        }

        dispatch(saveCatalogOverride(payload));
    };

    /**
     * Closes the result popup on success: collapses the accordion and closes compare popup/section.
     * On failure: only closes the result popup, leaving the compare popup open for retry.
     */
    const handleCatalogOverrideResultClose = (isSuccess: boolean) => {
        const fleetId = props?.purchaseOrderStepperData?.fleetRequestDetailId;
        setCatalogOverrideResultPopup({ isDialogVisible: false });
        dispatch(setCatalogOverrideSaved(null));
        if (isSuccess) {
            setShowCatalogComparePopup(false);
            setShowCatalogOverrideSection(false);
            setIsCatalogOverrideEnabled(false);
            props.onCatalogOverrideSaved?.(fleetId);
        }
    };

    /**
     * Handles the response from the catalog override save API.
     * On success: shows SuccessBee popup; compare popup stays open until user clicks Close.
     * On failure: shows ConfirmationBee popup; compare popup stays open for retry.
     */
    useEffect(() => {
        if (!catalogOverrideSaved) return;
        const fleetId = props?.purchaseOrderStepperData?.fleetRequestDetailId;
        if (catalogOverrideSaved.fleetRequestDetailId !== fleetId) return;
    const apiResponseMessage = catalogOverrideSaved?.message ;

        if (catalogOverrideSaved.success) {
            setCatalogOverrideResultPopup({
                isDialogVisible: true,
                titleImg: successBee,
                title: 'SUCCESS',
                isTitleWarning: false,
                subtextcontent: apiResponseMessage,
                outlineBtnText: 'Close',
                isSingleConfirmationBtn: true,
                popupOutlinebtnOnclick: () => handleCatalogOverrideResultClose(true),
            });
        } else {
            setCatalogOverrideResultPopup({
                isDialogVisible: true,
                titleImg: ConfirmationBee,
                title: '',
                isTitleWarning: false,
                subtextcontent: apiResponseMessage,
                outlineBtnText: 'Close',
                isSingleConfirmationBtn: true,
                popupOutlinebtnOnclick: () => handleCatalogOverrideResultClose(false),
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [catalogOverrideSaved]);

    return (
        <>
            <PurchaseDetail
                showPoolPopup={showPoolPopup}
                togglePopup={togglePopup}
                purchaseType={purchaseType}
                registeredType={registeredType}
                orderType={orderType}
                reasonCode={reasonCode}
                poolGridData={poolGridData}
                handleClickPick={handleClickPick}
                activeRow={activeRow}
                handleClickCancel={props.handleClickCancel}
                Popupcontent={props.Popupcontent}
                popupOutlinebtnOnclick={props.popupOutlinebtnOnclick}
                hideDialog={props.onDismiss}
                popupPrimarybtnOnclick={props.popupPrimarybtnOnclick}
                handleClickRestore={handleClickRestore}
                handleChange={props?.handleChange}
                handleChangeDropDown={props?.handleChangeDropDown}
                purchaseOrderStepperData={props?.purchaseOrderStepperData}
                errors={props.errors}
                skipVendorDetail={props.skipVendorDetail}
                savePurchaseOrder={props.savePurchaseOrder}
                assetPoolError={assetPoolError}
                setAssetPoolError={setAssetPoolError}
                isCompleted={props.isCompleted}
                isVehicleConsolidatedChecked={isVehicleConsolidatedChecked}
                isManageEquipConsolidatedChecked={isManageEquipConsolidatedChecked}
                isNonstandardConsolidatedChecked={isNonstandardConsolidatedChecked}
                itemDetails={props.itemDetails}
                handleBlurChange={props.handleBlurChange}
                unitPriceFormat={unitPriceFormat}
                check={check}
                onChangeDescription={onChangeDescription}
                onClick={onClick}
                isBulkOrderRequest={isBulkOrderRequest}
                isRequisitionComplete={isRequisitionComplete}
                isLicensedTitled={isLicensedTitled}
                getUserRoles={props.getUserRoles}
                vinValidationResult={props.vinValidationResult}
                onCatalogOverrideToggleChange={handleCatalogOverrideToggleChange}
                isCatalogOverrideEnabled={isCatalogOverrideEnabled}
                catalogOverridePopupcontent={catalogOverridePopupcontent}
                hideCatalogOverrideDialog={hideCatalogOverrideDialog}
                showCatalogOverrideSection={showCatalogOverrideSection}
                onSelectCatalogItem={handleSelectCatalogItem}
                catalogItemByAssetModelId={selectedCatalogCompareItem}
                showCatalogComparePopup={showCatalogComparePopup}
                setShowCatalogComparePopup={handleCloseCatalogComparePopup}
                originalBudgetingPrice={originalBudgetingPrice}
                newBudgetingPrice={newBudgetingPrice}
                isPriceThresholdViolation={isPriceThresholdViolation}
                SearchedCatalog={SearchedCatalog}
                isCatalogSearchDisabled={isCatalogSearchDisabled}
                isSearched={isSearched}
                orderDetails={props?.orderDetails}
                catalogOverrideDropDownValues={catalogOverrideDropDownValues}
                catalogOverrideCriteria={catalogOverrideCriteria}
                onCatalogOverrideDropdownChange={handleCatalogOverrideDropdownChange}
                onCatalogOverrideEquipmentTypeChange={handleCatalogOverrideEquipmentTypeChange}
                onManagedEquipSubFieldChange={handleManagedEquipSubFieldChange}
                // Local state isolates grid data from Redux — cleared on section close
                catalogGridData={catalogGridData}
                onSaveCatalogOverride={handleSaveCatalogOverride}
            />
            {catalogOverrideResultPopup?.isDialogVisible && (
                <PopupDialogbox
                    hideDialog={!catalogOverrideResultPopup.isDialogVisible}
                    onDismiss={() => catalogOverrideResultPopup.popupOutlinebtnOnclick?.()}
                    Popupcontent={catalogOverrideResultPopup}
                    popupOutlinebtnOnclick={() => catalogOverrideResultPopup.popupOutlinebtnOnclick?.()}
        popupPrimarybtnOnclick={() => {}}
                />
            )}
        </>
    );
};

export default PurchaseDetailContainer;
